/**
 * Entry point za javascript vezan za frame servise.
 */

/* global Ad, localVacAutoResize, triggerOnload */
import getSuggestedHeight from '@PROJECT_ROOT/assets/desktop/js/partner/getSuggestedHeight';
import initializePartnerMessaging from '@PROJECT_ROOT/assets/shared/js/partnerMessaging';
import { heightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';
import initializeNewTabLinks from '@PROJECT_ROOT/assets/shared/js/partner/newTabLinks';

$(initializeNewTabLinks);

/**
 * Metoda koja šalje poruke našim skriptama na partnerskom site-u za resize frame containera.
 *
 * Auto resize je uvijek omogućen.
 */
function resize(contentHeight) {
    const params = {};
    if (contentHeight) {
        const tempContentHeight = getSuggestedHeight(document);
        // eslint-disable-next-line eqeqeq
        if (tempContentHeight != contentHeight) {
            params.height = tempContentHeight;
            window.contentHeight = tempContentHeight;
        }
    }
    // Zadržano radi kompatibilnosti sa starom vac.js frame skriptom
    window.parent.postMessage(JSON.stringify(params), '*');
}

$(() => {
    initializePartnerMessaging();
});

$(() => {
    Ad.Error.initializeAjaxErrorHandler();

    const contentHeight = getSuggestedHeight(document);
    // scroll i resize na otvaranje nove stranice
    const height = getSuggestedHeight(document);
    let params;

    if (localVacAutoResize) {
        // resize na klik (potencijalno moze prosiriti sadrzaj)
        $(document).click(() => setTimeout(() => resize(contentHeight), 500));

        params = { height, scrolling: false };
    } else {
        params = { scrolling: false };
    }

    // Za novi frame je auto resize uvijek omogućen
    $(document).click(() => {
        setTimeout(() => window.parent.postMessage(heightChanged(getSuggestedHeight(document)), '*'), 500);
    });

    // Zadržano radi kompatibilnosti sa starom vac.js frame skriptom
    window.parent.postMessage(JSON.stringify(params), '*');

    triggerOnload();

    $(document).ajaxSuccess(() => {
        // resize na ajax request
        if (localVacAutoResize) {
            resize(contentHeight);
        } else {
            resize(false);
        }
        // Za novi frame je auto resize uvijek omogućen
        window.parent.postMessage(heightChanged(getSuggestedHeight(document)), '*');
    });
});
